export default "__VITE_ASSET__BqNjLQr9__"